/**
 * * Запрос на создания комментария
 */
export default class CreateTaskCommentRequest  {
	/**
	 * * Номер задачи
	 */
	TaskId!: number;
	/**
	 * * Номер проекта
	 */
	ProjectId!: number;
	/**
	 * * Родительский комментарий
	 */
	ParentId?: number;
	/**
	 * * Номер папки
	 */
	FolderId?: string;
	/**
	 * * Текст комментария
	 */
	Text!: string;
	constructor(obj?: Partial<CreateTaskCommentRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
